import React from 'react';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import FormLabel from '@active/react-ui/FormLabel';
import Input from '@active/react-ui/Input';
import Radio from '@active/react-ui/Radio';
import RadioGroup from '@active/react-ui/RadioGroup';
import Locale from '@active/react-utils/i18n/Locale';
import { accountNumberValidator, routingNumberValidator } from '../../utils/validators';
import BitMap from './BitMap';
import SaveInWallet from '../SaveInWallet';

const ECP = ({ allowSavingAccount, forceSaveInWallet, i18n }) => {
  const routingNumberValidate = (value) => {
    return routingNumberValidator(i18n, value);
  };
  const accountNumberValidate = (value) => {
    return accountNumberValidator(i18n, value);
  };
  return (
    <React.Fragment>
      <FormGroup name="accountName" required>
        <FormLabel htmlFor="accountName" >
          <Locale id="checkout.lib.components.payment.ecp.name" />
        </FormLabel>
        <FormField
          maxLength="50"
          autoComplete="off"
          id="accountName"
          as={Input}/>
      </FormGroup>
      <FormGroup name="bankRoutingNumber" required>
        <FormLabel htmlFor="bankRoutingNumber" >
          <Locale id="checkout.lib.components.payment.echeck.routing" />
        </FormLabel>
        <FormField
          id="bankRoutingNumber"
          autoComplete="off"
          as={Input}
          validate={routingNumberValidate}/>
      </FormGroup>
      <FormGroup name="accountNumber" required>
        <FormLabel htmlFor="accountNumber" >
          <Locale id="checkout.lib.components.payment.echeck.account" />
        </FormLabel>
        <FormField
          className="ecp-accountNumber"
          id="accountNumber"
          autoComplete="off"
          as={Input}
          validate={accountNumberValidate}/>
      </FormGroup>
      <FormGroup name="accountType" required className="ecp-accountType">
        <FormLabel htmlFor="accountType" >
          <Locale id="checkout.lib.components.payment.echeck.type" />
        </FormLabel>
        <FormField
          id="accountType"
          as={RadioGroup}>
          <Radio value="CONSUMER_SAVINGS">
            <Locale id="checkout.lib.components.payment.echeck.CONSUMER_SAVINGS" />
          </Radio>
          <Radio value="CORPORATE_SAVINGS">
            <Locale id="checkout.lib.components.payment.echeck.CORPORATE_SAVINGS" />
          </Radio>
          <Radio value="CONSUMER_CHECKING">
            <Locale id="checkout.lib.components.payment.echeck.CONSUMER_CHECKING" />
          </Radio>
          <Radio value="CORPORATE_CHECKING">
            <Locale id="checkout.lib.components.payment.echeck.CORPORATE_CHECKING" />
          </Radio>
        </FormField>
      </FormGroup>
      <SaveInWallet allowSavingAccount={allowSavingAccount} forceSaveInWallet={forceSaveInWallet}/>
      <BitMap />
    </React.Fragment>
  );
};

ECP.type = 'ECP';
ECP.defaultValues = {
  accountName: '',
  bankRoutingNumber: '',
  accountNumber: '',
  accountType: 'CONSUMER_SAVINGS',
  savingAccount: [],
};

export default ECP;
